"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ConfirmationCallCodeForm = require("./ConfirmationCallCodeForm");
Object.keys(_ConfirmationCallCodeForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ConfirmationCallCodeForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ConfirmationCallCodeForm[key];
    }
  });
});